import React from 'react'
import { AlertTriangle } from 'lucide-react'

import { Badge } from '@rewardops/replit/src/components/ui/badge'
import { Card, CardContent } from '@rewardops/replit/src/components/ui/card'
import { Skeleton } from '@rewardops/ui'

import { useApi } from '~/components/hooks/use-api'
import { PAWSectionType } from './paw-section-types'

export const NeedsAttention: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { api } = useApi()

  const { data: entitiesThatNeedAttention, isLoading } =
    api.pawDashboards.getByRole.useQuery({
      role: data?.role,
      sectionId: 'needs-attention',
    })
  return (
    <section data-testid={content?.sectionId} id={content?.sectionId}>
      <h2 className="mb-6 flex items-center gap-2 text-xl font-semibold">
        <AlertTriangle className="h-5 w-5 text-yellow-500" />
        {content?.title ?? 'needing attention'}
      </h2>
      {isLoading ? <Skeleton className="h-[200px] w-full" /> : null}
      {isLoading ? null : entitiesThatNeedAttention?.length === 0 ? (
        <Card className="overflow-visible">
          <CardContent className="p-6 text-center text-muted-foreground">
            All partners are performing well.
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-3">
          {entitiesThatNeedAttention?.map((metric: any) => (
            <Card key={metric.dealer.id} className="overflow-visible">
              <CardContent className="p-4">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div>
                    <p className="text-sm font-semibold">
                      {metric.dealer.name}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {metric.locationCount} stores
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    {metric.perf.revenueChange < -5 && (
                      <Badge variant="destructive">
                        Revenue {metric.perf.revenueChange}%
                      </Badge>
                    )}
                    {metric.perf.monthlyPoints < 3000 && (
                      <Badge variant="outline">
                        Low points: {metric.perf.monthlyPoints.toLocaleString()}
                      </Badge>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </section>
  )
}
